import ChevronLeft from "@mui/icons-material/ChevronLeft";
import styled from "styled-components";

const STEP_SHELL_WIDTH = "clamp(860px, 86%, 1200px)";

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: ${STEP_SHELL_WIDTH};
	margin: 0 auto;
`;

export const SegProgArea = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	width: 100%;
	padding: 8px 0 0;
`;

export const ButtonBack = styled.button<{ $isHidden: boolean }>`
	display: grid;
	flex-shrink: 0;
	place-items: center;
	width: 38px;
	height: 38px;
	margin-left: -8px;
	border: 0;
	border-radius: 999px;
	cursor: pointer;
	background-color: transparent;
	color: ${({ theme }) => theme.pantoneBlack};
	visibility: ${({ $isHidden }) => ($isHidden ? "hidden" : "visible")};
	transition: background-color 0.16s;

	&:hover {
		background-color: ${({ theme }) => theme.neutral.n100};
	}
`;

export const IconBack = styled(ChevronLeft)`
	&& {
		width: 22px;
		height: 22px;
	}
`;

export const Content = styled.div`
	width: 100%;
`;

export const Head = styled.div`
	max-width: 760px;
	padding: clamp(20px, 1.8vw, 28px) 0 clamp(24px, 2vw, 32px);
`;

export const Eyebrow = styled.span`
	display: block;
	margin-bottom: 9px;
	font-size: 11.5px;
	font-weight: 600;
	letter-spacing: 0.11em;
	text-transform: uppercase;
	color: ${({ theme }) => theme.neutral.n500};
`;

export const TitleArea = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 16px;
`;

export const Title = styled.h1`
	margin: 0;
	font-size: 32px;
	font-weight: 600;
	letter-spacing: -0.03em;
	line-height: 1.1;
	color: ${({ theme }) => theme.pantoneBlack};

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		font-size: 26px;
	}
`;

export const Subtitle = styled.p`
	margin: 12px 0 0;
	font-size: 16px;
	line-height: 1.5;
	color: ${({ theme }) => theme.neutral.n600};
`;

export const Footer = styled.div`
	width: 100%;
`;

export const LoadingArea = styled.div`
	display: grid;
	place-items: center;
	padding: 48px 0;
`;

export const BlockedBanner = styled.div`
	margin-bottom: 20px;
	padding: 14px 16px;
	border-radius: 10px;
	font-size: 13.5px;
	font-weight: 600;
	line-height: 1.5;
	background-color: ${({ theme }) => theme.errorLight};
	color: ${({ theme }) => theme.errorDark};
`;

export const ErrorArea = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 14px;
	text-align: center;
	color: ${({ theme }) => theme.neutral.n600};
`;
